import { logError } from '@zg-rentals/log-error';

export enum FULLSTORY {
  ANALYTICS_EVENT = 'leasing_web_analytics_event',
  ERROR = 'leasing_web_error',
  EVENT = 'leasing_web_event',
  LEASE_STATE_CHANGE = 'leasing_web_state_change',
}

// TODO - remove fullstory from leasing-web as we don't use it
// https://zillowgroup.atlassian.net/browse/LEAS-6556
export function getFullStoryInstance(userToken: string) {
  // Define unique Fullstory variable, default 'FS' keeps getting clobbered
  // https://help.fullstory.com/hc/en-us/articles/360020624694-What-if-the-identifier-FS-is-used-by-another-script-on-my-site-
  const FULLSTORY_NAMESPACE = 'FS';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fullStoryInstance = global[FULLSTORY_NAMESPACE] as any;

  if (fullStoryInstance == null) {
    // eslint-disable-next-line no-console
    console.warn(`FullStory wasn‘t initialized`);
  } else {
    try {
      fullStoryInstance.identify(userToken);
    } catch (err) {
      logError({
        error: err,
        errorType: 'GetFullStoryInstanceError',
        context: 'getFullStoryInstance',
      });
      // eslint-disable-next-line no-console
      console.warn('Can’t identify user in FullStory');
    }
  }

  return fullStoryInstance;
}

export function getCurrentSessionURL(userToken: string): string {
  const fullStoryInstance = getFullStoryInstance(userToken);

  if (fullStoryInstance) {
    try {
      const sessionUrl = fullStoryInstance.getCurrentSessionURL(true);
      // eslint-disable-next-line no-console
      console.info('FullStory link: ', sessionUrl);

      return sessionUrl;
    } catch (err) {
      logError({
        error: err,
        errorType: 'GetFullStorySessionURLError',
        context: 'getCurrentSessionURL',
      });
      // eslint-disable-next-line no-console
      console.warn(`Can't get FullStory session URL: ${err}`);
    }
  }
}

/**
 * FullStory functionality is injected by Google Tag Manager. If available, log to FullStory
 * @param type
 * @param details
 */
export function trackToFullStory(type: FULLSTORY, details: object = {}, userToken: string): string {
  const fullStoryInstance = getFullStoryInstance(userToken);

  if (fullStoryInstance) {
    try {
      fullStoryInstance.event(type, details);

      return getCurrentSessionURL(userToken);
    } catch (err) {
      logError({
        error: err,
        errorType: 'TrackToFullStoryError',
        context: 'trackToFullStory',
      });
      // eslint-disable-next-line no-console
      console.warn(`Error event not tracked to FullStory: ${err}`);
    }
  }

  return null;
}
